import { forwardRef } from 'react';
import { IconNames } from '@shipengine/giger-theme';
import { Typography } from '../../../Typography/Typography.js';
import { getFieldMessageStyles, getIconMessageStyles } from './FieldMessageStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { FieldMessageType } from './types/messageType.js';
import { Icon } from '../../../Icon/Icon.js';
import { IconSize } from '../../../Icon/types/size.js';

const FieldMessage = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    type,
    children,
    ...rest
  } = props;
  const iconName = {
    [FieldMessageType.INFO]: IconNames.INFO,
    [FieldMessageType.ERROR]: IconNames.ALERT,
    [FieldMessageType.SUCCESS]: IconNames.CHECK
  };
  return jsxs("span", {
    ref: ref,
    css: getFieldMessageStyles(type),
    ...rest,
    children: [type !== FieldMessageType.HINT && jsx(Icon, {
      name: iconName[type],
      size: IconSize.SIZE_SMALL,
      css: getIconMessageStyles
    }), jsx(Typography, {
      component: "small",
      variant: "small",
      children: children
    })]
  });
});
FieldMessage.displayName = 'FieldMessage';

export { FieldMessage };
//# sourceMappingURL=FieldMessage.js.map
